import React from 'react'
import { StyledFourthForm } from './styled'
import { FormType, OnChangeStep } from '../types'
import { FormProvider, useForm } from 'react-hook-form'
import { API } from 'javascripts/api'
import { WorkPreference, WorkPreferenceFormFormGroupEnum } from 'javascripts/api/generated'
import { useConfirmationBeforeUnload } from '../hooks/useConfirmationBeforeUnload'
import { WorkPreferenceFormNames } from '../../constants'
import { useAtom } from 'jotai'
import { stateAtom } from 'spa/member/atoms/WorkPreference/stateAtom'

type Props = {
  formType: FormType
  onChangeStep: OnChangeStep
}

export const FourthForm: React.FC<Props> = (props: Props) => {
  const [_state, setState] = useAtom(stateAtom)

  const { ...method } = useForm({
    defaultValues: async () => {
      const response = await API.getWorkPreference()
      const json: WorkPreference = response.data

      return {
        excluded_companies: json?.excluded_companies,
        work_from_abroad: json?.work_from_abroad?.toString(),
      }
    },
  })

  useConfirmationBeforeUnload(props.formType, method.formState.isDirty)

  const onSubmit = async (data) => {
    setState(prev => ({...prev, sending: true }))

    const formattedData = {
      ...data,
      work_from_abroad: data.work_from_abroad === "true",
      form_group: WorkPreferenceFormFormGroupEnum.AdditionalPreferences,
    }

    try {
      await API.updateWorkPreference(formattedData)
    } catch (error) {
      window.alert('エラーが発生しました。')
      return
    }

    // 次のステップがないので、sendingをfalseにしない

    // defaultValuesを再設定して、isDirtyの値をリセットする
    method.reset(data)

    props.onChangeStep('next')
  }

  return (
    <FormProvider {...method}>
      <form id={WorkPreferenceFormNames.Others} onSubmit={method.handleSubmit(onSubmit)} noValidate>
        <StyledFourthForm formType={props.formType} />
      </form>
    </FormProvider>
  )
}
